import {Select, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {Controller, useFormContext} from "react-hook-form";
import {LiveEventEventTypeFormFieldsType} from "../../../types";
import {StyledInputValue} from "../../../../../../live-classes/live-classes-form/live-classes-form.style";
import {CallDurationOptions} from "../../../../../session-bundle/session/gen-info/session-duration/call-duration-form-field";
import {LiveEventEventTypeTopicTypeSingleEventFormFieldProps} from "../types";

export function LiveEventEventTypeTopicTypeSingleEventDurationFormField({
  formType,
}: {
  formType: LiveEventEventTypeTopicTypeSingleEventFormFieldProps["formType"];
}) {
  const {control, getValues} = useFormContext<LiveEventEventTypeFormFieldsType>();
  const defaultValue = getValues("duration");
  const hasDefaultValue = formType === "edit";
  return (
    <div>
      <FormField
        id={"singleEventDuration"}
        label={"Event duration"}
        renderInput={(id) =>
          hasDefaultValue ? (
            <StyledInputValue>
              <p>{defaultValue} minutes</p>
            </StyledInputValue>
          ) : (
            <Controller
              control={control}
              name="duration"
              render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
                <Space size={16} direction="vertical" style={{display: "flex"}}>
                  <Select
                    id={id}
                    size="large"
                    status={error?.message ? "error" : undefined}
                    style={{width: "100%"}}
                    onChange={onChange}
                    value={value}
                    ref={ref}
                    onBlur={onBlur}
                    options={CallDurationOptions}
                    placeholder={"Please select a duration"}
                  />
                  <FormFieldError errorMessage={error?.message} />
                </Space>
              )}
            />
          )
        }
      />
    </div>
  );
}
